import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetPerson: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 11a4 4 0 100-8 4 4 0 000 8zm-7 10a7 7 0 0114 0" />
      </svg>
    </div>
  );
};

export default WidgetPerson;
